export class CustomLabelTranslation
{
    id: number;
    locale: string;
    name: string;
    external_link: string;
}
